import { useQuery } from '@tanstack/react-query';
import { getRelativeURLWithParams } from 'utils/url';
import { LD_FEATURE_FLAG } from 'constants/endpoints.api';

type FeatureFlagContext = {
  key: string | string[];
  kind: string;
  [prop: string]: unknown;
};

export const useFeatureFlagQuery = (
  flagKey: string,
  context: FeatureFlagContext
) => {
  const contextValues = Object.values(context || {});
  const queryKey = ['ld-flags', flagKey, ...contextValues];

  return useQuery({
    queryKey,
    enabled: !!flagKey && !!context?.key,
    queryFn: async (): Promise<{ [key: string]: boolean }> => {
      try {
        const url = getRelativeURLWithParams(
          `${LD_FEATURE_FLAG}/${encodeURIComponent(flagKey)}`,
          context
        );

        const res = await fetch(url);
        if (!res.ok) {
          return {};
        }
        return res.json();
      } catch (error) {
        console.error('Failed to fetch feature flag:', error);
        return {};
      }
    }
  });
};
